import { createContext } from "react";

const AuthContext = createContext('auth');

export default AuthContext;